import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogClose } from "../../@/components/ui/dialog";
import { Button } from "../../@/components/ui/button";
import { toast } from "sonner";
import axios from "axios";
import { api_endpoint } from "@/constants/constant";
import { useAuth } from "@clerk/clerk-react";
import { ClipLoader } from "react-spinners";

export default function DeletePathwayTypeDialog({ pathwayType, open, onOpenChange, onDeleted }) {
    const [loading, setLoading] = useState(false);
    const { getToken } = useAuth();

    const handleDelete = async () => {
        setLoading(true);
        try {
            const token = await getToken();
            if (!token) return;
            const reqConfig = {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            };

            await axios.delete(api_endpoint + `/pathway/levels/delete/${pathwayType.id}`, reqConfig);
            toast.success(`Pathway type "${pathwayType.type}" deleted successfully!`);
            onOpenChange(false);
            if (onDeleted) onDeleted(pathwayType.id);
        } catch (error) {
            toast.error("Failed to delete pathway type.");
        } finally {
            setLoading(false);
        }
    };

    if (!pathwayType) return null;

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-md h-auto">
                <DialogHeader>
                    <DialogTitle className="font-heading text-(--neutral-900)">Delete Pathway Type</DialogTitle>
                </DialogHeader>
                <div className="font-body text-(--neutral-800)">
                    Are you sure you want to delete the pathway type <b>{pathwayType.type}</b>? This action cannot be undone.
                </div>
                <DialogFooter className="flex gap-2 justify-between">
                    <DialogClose asChild>
                        <Button
                            variant="outline"
                            onClick={() => onOpenChange(false)}
                            disabled={loading}
                            className="">
                            Cancel
                        </Button>
                    </DialogClose>
                    <Button
                        variant=""
                        onClick={handleDelete}
                        disabled={loading}
                        className=""
                    >
                        {loading ? (
                            <span className="flex items-center justify-center w-full">
                                <ClipLoader size={20} color="#fff" />
                            </span>
                        ) : (
                            "Delete"
                        )}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}